import React from "react";
import {
    Box,
    Stack,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Tab,
} from "@mui/material";
import {
    Close,
    Save,
} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";

import PropTypes from "prop-types";

import BrandReportFilter from "./BrandReportFilter";
import { StyledNestedTabs } from "../../../../components/commonComponents/StyledComponents/styled";
import CloseButton from "../../../../components/commonComponents/Buttons/CloseButton";
import ActionButton, { DarkGreyButton } from "../../../../components/commonComponents/Buttons/ActionButton";
import { fetchBrandFilters, saveBrandFilters } from "../../../../api_calls/brandReport";
import ShareReport from "./ShareReport";

// to load tab content
function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const ReportFilter = ({ open, size, closeModal, campaignRecord }) => {
    const currentStateData = useSelector((state) => state.userSelections);
    const [tabValue, setTabValue] = React.useState(0);


    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    let tabs = [
        {
            label: "Report Filters",
            // icon: <Visibility />,
            unique_key: "brand_report_filters_section",
            content: <BrandReportFilter campaignRecord={campaignRecord} />,
        },
        {
            label: "Share Report",
            // icon: <Visibility />,
            unique_key: "share_report_sections",
            content: <ShareReport campaignRecord={campaignRecord} />,
        },
    ];

    return (
        <>
            <Dialog
                open={open}
                onClose={(e) => {
                    e.preventDefault();
                }}
                fullWidth={true}
                maxWidth={size}
                PaperProps={{
                    sx: {
                        height: 600,           // fixed height
                        maxHeight: 600,
                        display: 'flex',
                    },
                }}
            >
                <DialogTitle>
                    <strong>Brand Report</strong>
                </DialogTitle>
                <DialogContent>

                    <StyledNestedTabs value={tabValue} onChange={handleChange} aria-label="Brand report filter sections" textColor={"#F04B55"}>
                        {tabs.map((tabDetail) => {
                            return <Tab
                                key={tabDetail.unique_key}
                                aria-label={tabDetail.label}
                                label={tabDetail.label}
                                sx={{ width: "100%", maxWidth: "400px" }}
                                {...a11yProps(0)}
                            />;
                        })}
                    </StyledNestedTabs>

                    {/* ============== tab contents =========== */}
                    {tabs.map((tabDetail, index) => {
                        return (
                            <CustomTabPanel value={tabValue} index={index}>
                                {tabDetail.content}
                            </CustomTabPanel>
                        );
                    })}

                </DialogContent>

                <Box height={20} />
                <DialogActions>

                    {
                        tabValue === 0
                            ?
                            <Stack direction={"row"} spacing={2}>
                                <CloseButton
                                    onClick={(e) => {
                                        e.preventDefault();
                                        // reset the brand filters
                                        let viewMode = "";
                                        if (currentStateData?.brand_report_view === true) {
                                            viewMode = "Brand";
                                        }
                                        fetchBrandFilters(campaignRecord.campaign_id, viewMode);
                                        closeModal();
                                    }}
                                    label="Cancel"
                                    icon={<Close />}
                                />

                                <ActionButton
                                    onClick={(e) => {
                                        saveBrandFilters(campaignRecord.campaign_id);
                                    }}
                                    label={"Save"}
                                    icon={<Save />}
                                />
                            </Stack>
                            :
                            <Stack direction={"row"} spacing={2}>
                                <CloseButton
                                    onClick={(e) => {
                                        e.preventDefault();
                                        closeModal();
                                    }}
                                    label="Close"
                                    icon={<Close />}
                                />
                            </Stack>
                    }


                </DialogActions>
            </Dialog >

        </>
    );
};

export default ReportFilter;